<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success tw-text-center tw-ml-auto tw-w-full">
            <h2 class="tw-pt-8 lg:tw-pt-24">Muito obrigado<br> pelo seu pedido de<br> contacto.</h2>
            <p class="tw-pt-4 tw-pb-6 lg:tw-pb-16">Será contactado(a) pela nossa<br> equipa</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
    mounted() {
        gtag('event', 'conversion', { send_to: 'AW-659927348/64EDCJOAhNUBELTi1roC' });
    },
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';
.form-success {
    width: auto;
    height: auto;
    background-color: #fff;
    @screen lg {
        margin-top: 175px;
        margin-bottom: 210px;
        margin-left: auto;
        max-width: 400px;
        border-radius: 40px;
    }

    h2 {
        color: $main_color;
        text-transform: uppercase;
        font-weight: 900;
        font-size: 20px;
        line-height: 28px;
        @screen lg {
            font-size: 25px;
            line-height: 32px;
        }
    }

    p {
        color: $gray;
        font-size: 16px;
        line-height: 24px;
        @screen lg {
            font-size: 18px;
            line-height: 26px;
        }
    }
}

</style>
